import { cn } from '@/lib/utils';
import { Slot } from '@radix-ui/react-slot';
import { cva, type VariantProps } from 'class-variance-authority';
import React from 'react';

const headingVariants = cva('flex flex-row items-center m-0', {
    variants: {
        variant: {
            h1: 'text-base font-medium text-neutral-950',
            h3: 'leading-1 text-sm font-normal text-neutral-600',
        },
    },
    defaultVariants: {
        variant: 'h1',
    },
});

type HeadingProps = {
    asChild?: boolean;
} & React.HTMLAttributes<HTMLHeadingElement> &
    VariantProps<typeof headingVariants>;

const Heading = React.forwardRef<HTMLHeadingElement, HeadingProps>(
    ({ className, variant, asChild = false, ...props }, ref) => {
        const Comp = asChild ? Slot : variant || 'h1';
        return <Comp className={cn(headingVariants({ variant, className }))} ref={ref} {...props} />;
    },
);
Heading.displayName = 'Heading';

export { Heading, headingVariants };
